module.exports = __webpack_public_path__ + "media/125.db3dd9af.wav";